import React, {useEffect} from "react";
import {routesPath} from "../../../routes";
import ConsumptionManager from "../../../watering/manager/ConsumptionManager";
import ListConsumptionManager from "../../../watering/manager/ListConsumptionManager";
import Breadcrumb from "../../components/Utils/Breadcrumb";
import WateringTabNavigation from "../../components/Utils/WateringTabNavigation";
import {useHistory} from "react-router";
import {config} from "../../../config";
import ReactGA from "react-ga";

const Consumption = () => {
    const history = useHistory();
    useEffect(() => {
        if (config.googleAnalyticsId && history.location) {
            ReactGA.initialize(config.googleAnalyticsId);
            ReactGA.set({page: history.location.pathname}); // Update the user's current page
            ReactGA.pageview(history.location.pathname); // Record a pageview for the given page
        }
    }, [history.location.pathname]);

    const selectTabHandle = (tab: any) => {
        history.push(tab)
    }
    return (
        <div className="m-2 w-100 overflow-auto">
            <div className="row p-0 m-0">
                <div className="col-5 p-0 m-0 pl-2">
                    <Breadcrumb elements={[{text: "Consumption"}]}/>
                </div>
                <div className="col-7">
                    <WateringTabNavigation route={routesPath.consumption} selectTabHandle={selectTabHandle}/>
                </div>
            </div>

            <ConsumptionManager/>
            <ListConsumptionManager/>
        </div>
    );
};

export default Consumption;
